// extracted by mini-css-extract-plugin
export default {"headingTitle":"_2HnB4UMr","headingInstruction":"pmJQwxJ0","sectionBlock":"_1q6CDPqY","copy":"_3rjAcoKZ","copied":"oKBi394I"};